import { Component, OnInit, ViewChild } from '@angular/core';
import { DownloadExtensionControl, LanguageService } from '@lmnop/angular-core';
import { IUtils } from '@lmnop/web-core';
import { TranslateService } from '@ngx-translate/core';
import { PageBase } from 'app-src/private';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: 'home.page.html',
    styleUrl: './home.page.scss',
    standalone: false,
})
export class HomePage extends PageBase implements OnInit {
    constructor(
        protected override spinnerService: NgxSpinnerService,
        protected override translateService: TranslateService,
        protected override languageService: LanguageService
    ) {
        super(spinnerService, translateService, languageService);
        this.utils = this.ioc.core.utils;
    }

    public utils: IUtils;

    @ViewChild('downloadExtensionSpoilerProtection', { static: true })
    downloadExtensionSpoilerProtection: DownloadExtensionControl;

    public ngOnInit(): void {
        this.downloadExtensionSpoilerProtection.chromeStoreUrl = this.ioc.settings.extensionChromeStoreUrlSpoilerProtection;
        this.downloadExtensionSpoilerProtection.firefoxStoreUrl = this.ioc.settings.extensionFirefoxStoreUrlSpoilerProtection;

        $('.trigger-option').on('click', function (e) {
            (e.preventDefault(),
                (function () {
                    let $formOption = $('.quick-option');
                    $formOption.toggleClass('open');
                })());
        });
    }

    public openContactFormModal(event: string) {
        setTimeout(() => {
            $('#contact-form-tab').trigger('open');
        });
    }
}
